import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { useTheme } from "@mui/material";

import { ColoredCircle } from "@/Components/v2/atoms/ColoredCircle";
import { Grid } from "@/Components/v2/atoms/Grid";
import { Stack } from "@/Components/v2/atoms/Stack";
import { Tooltip } from "@/Components/v2/atoms/ToolTip";
import { Typography } from "@/Components/v2/atoms/Typography";

export interface MarkerLegendData {
  key: string;
  label: string;
  tooltip: string;
  color: string;
}

interface LegendProps {
  markerLegends: MarkerLegendData[] | undefined;
}

export const MarkerLegends: React.FC<LegendProps> = ({ markerLegends }) => {
  if (!markerLegends || markerLegends.length === 0) return null;
  const theme = useTheme();

  return (
    <Stack direction="row" justifyContent="flex-end" width={"100%"}>
      <Grid
        container
        spacing={1}
        sx={{
          maxWidth: "450px",
        }}
        paddingX={4}
      >
        {markerLegends.map((marker) => (
          <Grid item key={marker.key} xs={6}>
            <Stack direction="row" spacing={1} alignItems="center">
              <ColoredCircle color={marker.color} />
              <Typography variant="body2">{marker.label}</Typography>
              <Tooltip
                title={
                  <Typography
                    variant="body2"
                    padding={1}
                    sx={{ color: theme.palette.common.white }}
                  >
                    {marker.tooltip}
                  </Typography>
                }
                placement="bottom"
              >
                <HelpOutlineOutlinedIcon
                  sx={{
                    color: theme.palette.brandedTypography.textColor,
                    width: "20px",
                    height: "20px",
                  }}
                />
              </Tooltip>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};
